import {
  Alert,
  AlertDescription,
  AlertTitle,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/alert';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  Card,
  CardContent,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/card';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import { Skeleton } from '@art-of-hospitality-solutions-llc/ui-kit/components/skeleton';
import { Link } from 'react-router-dom';

import Breadcrumbs from '@Components/Breadcrumbs';
import { useApps } from '@Hooks/useApps';

export default function ContentEditorList() {
  const appsQuery = useApps();

  return (
    <div className="content-editor-list">
      <Breadcrumbs
        navList={[{ name: 'Content Editor', href: '/content-editor' }]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>App Content Editor</Heading>
          <p>Manage the content of your apps.</p>
        </div>
      </div>

      {appsQuery.isError && (
        <Alert variant="destructive">
          <AlertTitle>Unable to load apps</AlertTitle>
          <AlertDescription>
            Something went wrong loading your apps. Please try again.
          </AlertDescription>
        </Alert>
      )}

      {appsQuery.isLoading && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <Skeleton className="h-28 w-full rounded-xl" />
          <Skeleton className="h-28 w-full rounded-xl" />
        </div>
      )}

      {appsQuery.isSuccess && appsQuery.data.length === 0 && (
        <Card>
          <CardContent>
            <p className="text-sm text-zinc-500">
              No apps are configured for this tenant yet.
            </p>
          </CardContent>
        </Card>
      )}

      {appsQuery.isSuccess && appsQuery.data.length > 0 && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {appsQuery.data.map((app) => (
            <Card key={app.id}>
              <CardContent className="flex items-center justify-between gap-4">
                <div className="min-w-0">
                  <div className="truncate font-medium">{app.name}</div>
                  <div className="truncate text-sm text-zinc-500">
                    {app.domain}
                  </div>
                </div>
                <Button asChild>
                  <Link to={`/content-editor/${app.id}`}>Edit content</Link>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
